export const formatPhoneNumber = (input: string): string => {
  if (!input) return input;

  const phoneNumber = input.replace(/[^\d]/g, '');

  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber;

  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )} - ${phoneNumber.slice(6, 10)}`;
};

export const formatDob = (value: string) => {
  const currentDob = value.replace(/[^\d]/g, '');
  if (
    currentDob.length > 1 &&
    Math.max(...currentDob.split('').map((val) => +val)) == 0
  ) {
    return '';
  }
  const currentDobLength = currentDob.length;
  if (currentDobLength < 3) return currentDob;
  if (currentDobLength < 5)
    return `${currentDob.slice(0, 2)}/${currentDob.slice(2, 4)}`;

  return `${currentDob.slice(0, 2)}/${currentDob.slice(
    2,
    4
  )}/${currentDob.slice(4, 8)}`;
};

export const formatDateValue = (date: number): string => {
  return String(date).padStart(2, '0');
};

export const formatFullSSN = (value: string) => {
  const currentSSN = value.trim().replace(/[^\d]/g, '');
  const currentSSNLength = currentSSN.length;
  if (currentSSNLength < 4) return currentSSN;
  if (currentSSNLength < 6)
    return `${currentSSN.slice(0, 3)}-${currentSSN.slice(3, 5)}`;

  return `${currentSSN.slice(0, 3)}-${currentSSN.slice(
    3,
    5
  )}-${currentSSN.slice(5, 9)}`;
};

export const formatSSN = (value: string) => {
  return value.trim().replace(/[^\d]/g, '');
};

export const formatState = (input: string): string => {
  // Only accept letter characters
  const result = input.match(/^[A-Za-z]+$/g);
  if (result) {
    return result.join('').substring(0, 5);
  }
  return '';
};

export function displayNumberFromBE(val: any) {
  if (val === undefined) {
    return '--';
  }

  // remove trailing zeros if '.00'
  let toDisplay = val.displayValue;
  if (toDisplay.endsWith('.00')) {
    toDisplay = `${toDisplay.substring(0, toDisplay.length - 3)}`;
  }

  if (val.displaySymbol !== undefined && val.displaySymbol !== '') {
    return `${val.displaySymbol}${toDisplay}`;
  }

  if (val.displayUnit !== undefined && val.displayUnit !== '') {
    return `${toDisplay}${val.displayUnit}`;
  }

  return `${toDisplay}`;
}

export function displayNumberNone(val: any, language: any) {
  if (val === undefined) {
    return '--';
  }

  if (val.valueInMinUnit === 0) {
    return language.none;
  }

  // remove trailing zeros if '.00'
  return displayNumberFromBE(val);
}

export const getTodaysDateInNumbers = () => {
  const today = new Date();
  const year = today.getFullYear().toString();
  const month = (today.getMonth() + 1).toString().padStart(2, '0');
  const day = today.getDate().toString().padStart(2, '0');
  return year + month + day;
};

export const formatRewardsBonus = (rewardsBonus: any) => {
  const { amount, amountSubtext } = rewardsBonus;

  return `${amount}${amountSubtext ? ` ${amountSubtext}` : ''}`;
};

export const toTitleCase = (str: string) =>
  str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
